/**
 * code-block 기능 슬라이스 — controls-only.
 * codeBlock 자체(렌더/직렬화/슬래시)는 코어(serialize/block.js·editing.js·slash)에 있고,
 * 이 슬라이스는 "구문강조 + 언어 선택" 확장만 컨트롤로 기여한다(A1, 무의존).
 */
import { attachCodeHighlight } from "./controls.js";

export default {
  name: "code-block",
  controls: attachCodeHighlight,
};
